import {Suspense} from "react";
import {RouterProvider} from "react-router-dom";
import {Provider} from "./Components/ui/provider";
import {Toaster} from "./Components/ui/toaster";
import {CalculatorContextProvider} from "./context/calculatorContext";
import {PricingContextProvider} from "./context/pricingContext";
import {router} from "./routes";
import "./App.css";

function App() {
  return (
    <Provider>
      <Toaster />
      <PricingContextProvider>
        <CalculatorContextProvider>
          <Suspense fallback={null}>
            <RouterProvider router={router} />
          </Suspense>
        </CalculatorContextProvider>
      </PricingContextProvider>
    </Provider>
  );
}

export default App;
